// extracted by mini-css-extract-plugin
module.exports = {"hero":"Season_hero__1lqKg","season-1":"Season_season-1__mgItl","hero-border":"Season_hero-border__3P3Rg","container":"Season_container__2skPJ"};